import truncate from 'truncate-html';

export const handleTruncate = (self, skipClicks = false) => {
	if(self.summaryText.length > self.limit) {
		let readMore = `<span class="read-more is-more">Read more</span>`;
		let readLess = `<span class="read-more is-less">Read less</span>`;

		// trim the string
		let trimmedHtml = truncate(self.summaryHtml, self.limit, {
			ellipsis: ` ... ${readMore}`
		});

		self.$summary.html(trimmedHtml);

		if(!skipClicks) {
			self.$element.on('click', `.read-more`, (e) => {
				if($(e.currentTarget).hasClass('is-more')) {
					self.$summary.html(self.originalHtml + ' ' + readLess);
					$(e.currentTarget).removeClass('is-more').text('Read less');
				}
				else {
					self.$summary.html(trimmedHtml);
					$(e.currentTarget).addClass('is-more').text('Read more');
				}
			});
		}
	}
};
